/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElSelect as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-left": "6px"
  }
}, "%", -1);
const _hoisted_2 = {
  class: "dialog-footer"
};
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消");
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 确定 ");
import { apiAddGS, apiEditGS } from '@/api/gsManage';
export default /*#__PURE__*/_defineComponent({
  props: {
    gid: null
  },
  emits: ['ok'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const props = __props;
    const dividedOptions = reactive([{
      label: '10',
      value: 10
    }, {
      label: '20',
      value: 20
    }, {
      label: '30',
      value: 30
    }, {
      label: '40',
      value: 40
    }, {
      label: '50',
      value: 50
    }, {
      label: '60',
      value: 60
    }, {
      label: '70',
      value: 70
    }, {
      label: '80',
      value: 80
    }, {
      label: '90',
      value: 90
    }, {
      label: '100',
      value: 100
    }]);
    const dialogVisible = ref(false);
    const formData = ref({
      game_id: 0,
      name: '',
      phone: '',
      rate: undefined,
      remark: ''
    });
    const formDataRef = ref();
    const validateDivided = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择GS分成比例'));
      } else {
        const reg = /^(?:[1-9]|[1-9]\d|100)$/;
        if (!reg.test(value)) {
          callback(new Error('请输入1-100正整数'));
        }
        callback();
      }
    };
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'));
      } else {
        const reg = /^(1[3-9])\d{9}$/;
        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'));
        }
        callback();
      }
    };
    const rules = reactive({
      name: [{
        required: true,
        message: '请输入GS名称',
        trigger: 'blur'
      }],
      phone: [{
        required: true,
        validator: validatePhone,
        trigger: 'blur'
      }],
      rate: [{
        required: true,
        validator: validateDivided,
        trigger: 'blur'
      }]
    });
    const handleClose = ruleForm => {
      dialogVisible.value = false;
      if (!ruleForm) return;
      ruleForm.resetFields();
    };
    const handleOk = ruleForm => {
      if (!ruleForm) return;
      ruleForm.validate(async valid => {
        if (!valid) return;
        const api = type.value === 'add' ? apiAddGS : apiEditGS;
        const res = await api({
          ...formData.value,
          game_id: props.gid,
          rate: Number(formData.value.rate) * 100
        });
        if (res.code === 0) {
          handleClose(formDataRef.value);
          emits('ok');
        }
      });
    };
    const type = ref('add');
    const show = payload => {
      dialogVisible.value = true;
      type.value = payload.type;
      if (payload.data) {
        formData.value = {
          ...payload.data,
          rate: Number(payload.data.rate) / 100
        };
      }
    };
    expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_input = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_option = __unplugin_components_2;
      const _component_el_select = __unplugin_components_3;
      const _component_el_form = __unplugin_components_4;
      const _component_el_button = __unplugin_components_5;
      const _component_el_dialog = __unplugin_components_6;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => dialogVisible.value = $event),
        title: `${type.value === 'add' ? '添加' : '编辑'}GS`,
        width: "600px",
        "before-close": () => handleClose(formDataRef.value)
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = () => handleClose(formDataRef.value))
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[5] || (_cache[5] = () => handleOk(formDataRef.value))
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formDataRef",
          ref: formDataRef,
          model: formData.value,
          rules: _unref(rules),
          "label-width": "120px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "管理员GS名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.name = $event),
              minlength: "1",
              maxlength: "20",
              placeholder: "输入管理员GS名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "管理员手机号",
            prop: "phone"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: formData.value.phone,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.phone = $event),
              minlength: "1",
              maxlength: "20",
              placeholder: "输入管理员手机号"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "推广分成",
            prop: "rate"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: formData.value.rate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.rate = $event),
              filterable: "",
              "allow-create": "",
              "default-first-option": "",
              "reserve-keyword": false,
              placeholder: "输入自定义数字按回车以自定义数据（正整数）",
              style: {
                "width": "90%"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dividedOptions), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"]), _hoisted_1]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "备注",
            prop: "remark"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "textarea",
              modelValue: formData.value.remark,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formData.value.remark = $event),
              maxlength: "200",
              placeholder: "输入备注"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title", "before-close"]);
    };
  }
});